// third
import { FirebaseOptions } from "@angular/fire/app";



export const ProductionEnvironmentName = 'production-01';
export const DevelopmentEnvironmentName = 'development-01';
export const LocalEnvironmentName = 'local-01';

export const environmentFirebaseConfig: FirebaseOptions = {
    "projectId": "t2pp-adildos-01",
    "appId": "1:584374698396:web:8d6f8dbb0e3ead068d0859",
    "storageBucket": "t2pp-adildos-01.firebasestorage.app",
    "apiKey": "AIzaSyCwA_h1_EduXofBL4REwHOf57RGfCP9wjM",
    "authDomain": "t2pp-adildos-01.firebaseapp.com",
    "messagingSenderId": "584374698396",
    "measurementId": "G-CECVTGSS57",
};
